import React from "react";
import { FaQuoteLeft } from "react-icons/fa";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const Testimonial = () => {
  const testominal = [
    {
        id: 1,
        para: `I believe in their values of keeping on the top of the priority list, working with devotion, and supplying the best standards approach. `,
        img:`./Assets/img/test7.webp`,
        name:`James`,
        place:`CEO, Keen IT Solution`,
    },
    {
        id: 2,
        para: `I believe in their values of keeping on the top of the priority list, working with devotion, and supplying the best standards approach. `,
        img:`./Assets/img/test7.webp`,
        name:`James`,
        place:`CEO, Keen IT Solution`,
    },
    {
        id: 3,
        para: `I believe in their values of keeping on the top of the priority list, working with devotion, and supplying the best standards approach. `,
        img:`./Assets/img/test7.webp`,
        name:`James`,
        place:`CEO, Keen IT Solution`,
    },
    {
        id: 4,
        para: `I believe in their values of keeping on the top of the priority list, working with devotion, and supplying the best standards approach. `,
        img:`./Assets/img/test7.webp`,
        name:`James`,
        place:`CEO, Keen IT Solution`,
    },
    {
      id: 5,
      para: `I believe in their values of keeping on the top of the priority list, working with devotion, and supplying the best standards approach. `,
      img:`./Assets/img/test7.webp`,
      name:`James`,
      place:`CEO, Keen IT Solution`,
    },
  ];
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 2,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 992, min:464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <section className="testimonial p-top p-btm">
      <div className="container">
        <span className="title">TESTIMONIALS</span>
        <h2 className="text-center">What Saying Customers</h2>
        {/* <div className="flex spce-btwn"> */}
        <Carousel
          responsive={responsive}
          infinite={true}
          autoPlaySpeed={3000}
          arrows={false}
          autoPlay={true}
        >
          {testominal.map((testEle) => {
            return (
              <>
                <div className="test-item" key={testEle.id}>
                  <div className="box">
                    <FaQuoteLeft />
                    <p>{testEle.para}</p>
                  </div>
                  <div className="posted-by  flex align-center">
                    <div className="avtar">
                      <img src={testEle.img} alt="avtar" />
                    </div>
                    <div className="avatar-name">
                      <h4>{testEle.name}</h4>
                      <p>{testEle.place}</p>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </Carousel>
      </div>
      {/* </div> */}
    </section>
  );
};
export default Testimonial;
